import { render, staticRenderFns } from "./FirmDetail.vue?vue&type=template&id=1bb8a4b0&scoped=true&"
import script from "./FirmDetail.vue?vue&type=script&lang=js&"
export * from "./FirmDetail.vue?vue&type=script&lang=js&"
import style0 from "./FirmDetail.vue?vue&type=style&index=0&id=1bb8a4b0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bb8a4b0",
  null
  
)

export default component.exports